module.exports = __webpack_public_path__ + "img/3_Dicks_Screen_L_1_L.ff838a03.jpg";